import Vue from 'vue'
import Component from '../shared/component'
import Relation, {HasMany, MemberOf} from '../shared/mixins/relation'

const translationReplacements = Relation()
const translationProvider = Relation()

class TranslationEntry {
  constructor (content, tags) {
    this.content = content
    this.tags = tags
  }

  replace (tag, replacement, count) {
    let {content} = this

    if (count !== undefined) {
      const before = this.tags.find(t => t.tag === tag)

      if (before) {
        const {tag, cases} = before
        const {zero, one, more} = cases

        content = replace(
          content,
          tag,
          count === 0 ? zero : count === 1 ? one : more
        ).join('')
      }
    }

    return new TranslationEntry(
      replace(content, tag, replacement).join(''),
      this.tags
    )
  }

  translate () {
    return this.content
  }
}

Vue.mixin({
  inject: {
    [translationProvider.key]: {
      name: translationProvider.key,
      default: null
    }
  },

  methods: {
    $translation ({name, content, tags}) {
      const provider = this.translate
        ? this
        : this[translationProvider.key]

      return new TranslationEntry(
        name && provider
          ? provider.translate(name)
          : content,
        tags
      )
    }
  }
})

export const Translation = Component('v-translation', {
  mixins: [
    HasMany(translationReplacements, 'replacements')
  ],
  props: {
    name: {
      type: String,
      default: null
    },
    content: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      translation: this.content
    }
  },
  created () {
    const provider = this[translationProvider.key]

    if (this.name && provider) {
      const result = provider.translate(this.name)

      if (result) {
        this.translation = result
      }
    }
  },
  render (createElement) {
    const children = this.$slots.default

    const parts = this.translation
      .split(/(\[[a-z_]+\])/i)
      .map(part => {
        const match = part.match(/\[([a-z_]+)\]/i)

        if (!match) {
          return part
        }

        const tag = match[1]

        const replacement = children.find(child => {
          const {componentOptions: options} = child

          if (!options) {
            return false
          }

          const {propsData: attrs} = options

          if (attrs.tag === tag) {
            child.key = tag

            return true
          }
        })

        return replacement || part
      })

    return createElement(
      'span',
      {
        class: 'translation'
      },
      parts
    )
  }
})

export const TranslationReplacement = Component('v-translation-replacement', {
  mixins: [
    MemberOf(translationReplacements, 'translation')
  ],
  props: {
    tag: {
      type: String,
      required: true
    }
  },
  render (createElement) {
    return createElement(
      'span',
      {
        class: 'translation-replacement'
      },
      this.$slots.default
    )
  }
})

function replace (input, tag, replacement) {
  const parts = input.split(`[${tag}]`)

  return parts
    .map(part => [part, replacement])
    .reduce((a, b) => a.concat(b))
    .slice(0, -1)
}

export const TranslationProvider = {
  provide () {
    return {
      [translationProvider.key]: this
    }
  },
  methods: {
    translate (name) {
      return name
    }
  }
}
